import { BrowserCacheLocation, Configuration, RedirectRequest, SilentRequest } from '@azure/msal-browser'

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID as string,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_LOGIN_REDIRECT_URI as string,
  },
  cache: {
    secureCookies: Boolean(process.env.REACT_APP_HTTPS_COOKIES),
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true,
  },
}

export const loginRequest: RedirectRequest = {
  scopes: ['User.Read'],
}

export const tokenRequest: SilentRequest = {
  scopes: [`${process.env.REACT_APP_API_SCOPE_NAME}`],
}
